import React, { useEffect, useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  fetchSiblings as fetchSiblingsAction
} from '../actions/mindItems.actions';
import {
  fetchAttachments as fetchAttachmentsAction,
  fetchProduct as fetchProductAction,
} from '../actions/product.actions';
import {
  selectMindItem,
  isMindItemInvalid as isMindItemInvalidSelector,
} from '../reducers/mindItems.selectors';
import { selectUser } from '../reducers/user.selectors';
import { ReaderContext } from '../components/Reader/ReaderContext';
import { routes } from '../constants';
import MasterLayout from '../components/AppLayout/MasterLayout';
import { setCustomPageTitle } from '../utils/customTitle';
import useAction from '../utils/useAction';
import useRouter from '../utils/useRouter';
import Reader from '../components/NewReader/NewReader';
import { trackContentViewed } from '../utils/tracking';
import { getPositionFromState, getPositionFromQuery } from '../utils/searchUtils';
import { getCurrentSearchId } from '../utils/ampli';
import { notifyBugsnagHandledError } from '../utils/bugsnagClient';
import useHydrateSearchStateFromUrl from '../utils/useHydrateSearchStateFromUrl';

const ReaderPage = () => {
  const { match, router } = useRouter();
  const { location: { query, state } } = match;
  const fetchProduct = useAction(fetchProductAction);
  const fetchSiblings = useAction(fetchSiblingsAction);

  useHydrateSearchStateFromUrl();

  const {
    setInitialPage,
    mindItemId: documentId,
    showNewReader,
  } = useContext(ReaderContext);

  const mindItem = useSelector(state => selectMindItem(state, documentId));

  const user = useSelector(selectUser);
  const isMindItemInvalid = useSelector(state => isMindItemInvalidSelector(state, documentId));

  useEffect(() => {
    if (query && query.page) {
      const newInitPage = parseInt(query.page);
      setInitialPage(newInitPage > 0 ? newInitPage : 1);
    }
    else {
      setInitialPage(1);
    }
  }, [query]);

  const trackedMindItemIdRef = useRef<string>();

  useEffect(() => {
    if (mindItem) {
      fetchProduct(mindItem.product);
      fetchSiblings(mindItem.id, mindItem.product);
      fetchAttachmentsAction(mindItem.product);
      setCustomPageTitle(mindItem.title);

      if (user && trackedMindItemIdRef.current !== mindItem.id) {
        trackedMindItemIdRef.current = mindItem.id;
        const position = getPositionFromState(state) ?? getPositionFromQuery(query);
        const searchId = getCurrentSearchId() || query?.search_id;
        trackContentViewed(mindItem, position, searchId).catch(notifyBugsnagHandledError);
      }
    }
  }, [mindItem?.product, mindItem?.id, user?.id, state]);

  useEffect(() => {
    if (isMindItemInvalid) {
      router.replace(`/${routes.dashboard.root}`);
    }
  }, [isMindItemInvalid, router]);

  if (isMindItemInvalid) return <></>;

  if (!user || !mindItem) return <></>;

  return (
    <MasterLayout hideTopBar={showNewReader}>
      <Reader />
    </MasterLayout>
  );
};

export default ReaderPage;
